import { Component, OnInit, Inject, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatStepper } from '@angular/material/stepper'
import { Channel } from '@tokeet-frontend/tv3-platform'
import { ConnectBDCWizardStep4Component } from './step4/connect-bdc-wizard-step4.component'

@Component({
  selector: 'app-connect-bdc-wizard',
  templateUrl: './connect-bdc-wizard.component.html',
  styleUrls: ['./connect-bdc-wizard.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class ConnectBDCWizardComponent implements OnInit {
  @ViewChild(MatStepper) stepper: MatStepper
  @ViewChild('step4') step4: ConnectBDCWizardStep4Component
  isConnected = false

  get channel() {
    return this.data.channel
  }

  propertyId: string

  constructor(
    public dialogRef: MatDialogRef<ConnectBDCWizardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { channel: Channel }
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close(this.isConnected)
  }

  onConnected(propertyId: string) {
    this.propertyId = propertyId
    this.isConnected = true
    this.stepper.next()
  }

  onDone() {
    this.dialogRef.close('done')
  }

  onChannel() {
    this.dialogRef.close('channel')
  }
}
